import BaseObject, { BaseObjectParams } from './baseObject';
import Game from './game';
import Ship from './element/ship/ship';
import CapitalShip from './element/ship/capitalShip';

export interface PlayerParams extends BaseObjectParams {
  game: Game;
  resources?: number;
}

export default class Player extends BaseObject implements PlayerParams {
  game!: Game;
  resources: number = 0;

  capitalShip!: CapitalShip;
  jumpedOutShips: Ship[] = [];

  constructor(params?: PlayerParams) {
    super();
    this.applyParams(params);
  }

  collectResources(amount: number): void {
    this.resources = Math.ceil(this.resources + Math.abs(amount));
  }

  payResources(amount: number): boolean {
    if (this.resources < Math.abs(amount))
      return false; // could not pay
    this.resources = Math.ceil(this.resources - Math.abs(amount));
    return true;
  }

  displayResources(): void {
    const { interfaceCanvas: ctx } = this.game.contexts;

    ctx.save();
    ctx.fillStyle = 'white';
    ctx.strokeStyle = 'black';
    ctx.font = '30px Arial';
    const text = `Resources: ${Math.round(this.resources)}`;
    const textMetrics = ctx.measureText(text);
    const startX = ctx.canvas.width - textMetrics.width;
    ctx.textBaseline = 'top';
    ctx.fillText(text, startX, 0);
    ctx.restore();
  }

  displayPause(): void {
    const { canvasWidth, canvasHeight, contexts: { interfaceCanvas: ctx } } = this.game;

    ctx.save();
    ctx.fillStyle = 'white';
    ctx.strokeStyle = 'black';
    ctx.font = '80px Arial';
    const text = 'Game paused';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, canvasWidth / 2, canvasHeight / 2);
    ctx.restore();
  }
}
